// Nginx will treat headers with underscores as invalid and drop them... for funsies.
export const DASHBOARD_HEADER = { requestsource: "dashboard" };
